import React, { useEffect, useState } from "react";
import { motion, useMotionValue, animate } from "framer-motion";
import "./CSS/MyProgress.css";

const greetings = [
  "You’re spending another meaningful day with them!🌟",
  "Your presence paints joy on your child’s canvas! 🖌️❤️",
  "Every smile today is thanks to your love! 😊💖",
  "Another day, another beautiful chapter 📖✨",
  "Your patience is shaping a future with possibilities. 🧠🌈",
  "The bond you’re building today will last a lifetime. 🤝💕",
  "Your love is the magic that makes their day special.✨💖",
  "Tiny steps, big victories - celebrating them all. 👣🎉",
  "Thank you for showing up with grace and grit. 🌼💪",
  "You're not just raising a child — you’re raising hope. 🌱",
  "In your warmth, your child finds their strength. 🔥💪",
  "Today’s effort, tomorrow’s triumphs. Keep going! 🚀",
  "Your love helps your child soar above challenges. 🕊️✨",
  "Every hug, every word — it all matters. 🤗💬",
  "You're building resilience through compassion. 🧩🛡️",
  "Hope grows wherever you walk with your child. 👟🌿",
  "Because of you, your child is unstoppable. 🏃‍♀️💫",
  "A heart like yours can light up the darkest days. 💡❤️",
  "You’re making a difference every single day. 🙌",
  "Your belief in your child builds bridges to new worlds.🌎",
  "Even the smallest act of love can be monumental. 🪄❤️",
  "Your kindness echoes through your child’s journey. 🔊🌈",
  "You’re their safe place and their springboard. 🏡🚀",
  "Your love is the foundation of their dreams. 🏗️💭",
  "You may not see it, but you’re their hero. 🦸‍♀️🦸‍♂️",
  "You are exactly what your child needs 🌺",
  "Your patience is changing lives. 🕰️💞",
  "Thank you for showing up with love, again.❤️",
  "You're weaving a world of wonder for your little one.🧵",
  "In your arms, they find courage and in you they find home. 🏠💖",
  "Because of your love, the world feels kinder. 💫🌈",
  "You're the quiet force behind their loudest laughter. 🎈",
  "Today’s snuggles, tomorrow’s strength 🤗💪",
  "Your presence is the greatest present for them.❤️",
  "You're the melody in their earliest memories. 🎶👶",
  "Your love is the anchor in their sea of dreams. ⚓️🌊",
  "You’re the reason they believe in magic. ✨🪄",
  "Your love is the compass guiding their journey. 🧭❤️",
  "Every moment spent together is a treasure. 💎",
];

// Counter component for animating numbers
const Counter = ({ target }) => {
  const count = useMotionValue(0);
  const [display, setDisplay] = useState(0);

  useEffect(() => {
    const controls = animate(count, target, {
      duration: 3,
      ease: "easeOut",
      onUpdate: (latest) => setDisplay(Math.floor(latest)),
    });
    return controls.stop;
  }, [target, count]);

  return <span>{display}</span>;
};

const MyProgress = ({
  userId,
  totalSessions,
  timeSpent,
  messagesSent,
  streakDays,
  showGreeting = true,
  headerAddon = null,
}) => {
  const stats = [
    { label: "Videos Uploaded", value: totalSessions || 0 },
    { label: "Time Spent (mins)", value: timeSpent || 0 },
    { label: "Messages Sent", value: messagesSent || 0 },
    { label: "Days Streak", value: streakDays || 0 },
  ];

  const [greeting, setGreeting] = useState("");

  useEffect(() => {
    const randomGreeting = greetings[Math.floor(Math.random() * greetings.length)];
    setGreeting(randomGreeting);
  }, []);

  return (
    <div className="my-progress-container">
      {}
      <div className="progress-header">
        <span className="blue-dot" />
        <h2>My Progress 🚀</h2>
      </div>
      {}
      <div className="green-divider" />
      {headerAddon && (
        <div className="progress-header-addon">
          {headerAddon}
        </div>
      )}
      {}
      <div className="badge-container">
        {stats.map((stat, index) => (
          <motion.div
            key={index}
            className="progress-badge"
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.4, delay: index * 0.2 }}
          >
            <h3 className="badge-value">
              <Counter target={stat.value} />
            </h3>
            <p className="badge-label">{stat.label}</p>
          </motion.div>
        ))}
      </div>
    
      {showGreeting && (
        <div className="greeting-message">
          <p>{greeting}</p>
        </div>
      )}
    </div>
  );
};

export default MyProgress;
